import React from "react";
import banner_default from "../../../assets/background_banners.webp";
import { connect } from "react-redux";
import store_default from "../../../assets/store_default.png";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import message_icon from "../../../assets/message_icon.svg";
import cloud_file from "../../../assets/cloud_file.svg";
import ButtonPage from "../../comman/button/ButtonPage";

function StoreProfile(props) {

  const { t } = useTranslation();

    let banner_image = "";
    if(props?.type === "StoreDetails"){
      if (props?.storedetail?.banner_image === null) {
        banner_image =banner_default 
      } else if(props?.storedetail?.banner_image){
        banner_image = props?.storedetail?.banner_image[0]
      }
    }else if(props?.editBanner){
      banner_image = props?.storedetail?.bannerImageArray
    }else{
      if (props?.storedetail?.banner_image === null) {
        banner_image = banner_default
      } else if(props?.storedetail?.banner_image?.length > 0 ){
        banner_image = props?.storedetail?.banner_image[0]
      }else{
        banner_image = banner_default
      }
    }

  const navigateTochat = (e) => {
    localStorage.clear("chatList");
    props?.navigate(e);
  }



  return (
    <div className="main_banner">
      <div className={props?.innerClass}>
        <div className={props?.className}>
          <div className="img">
            <div
              className="background_banner_setUp"
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0,  0.9)), url('${banner_image}')`,
              }}
            ></div>
          </div>
          <div className="store-info">
            <div className={"flex"}>
              <div className="card-image">
              {props?.type === "StoreDetails"?(
                  <LazyLoadImage
                  src={
                    props?.storedetail?.images === null ||
                    typeof props?.storedetail?.images === "undefined"
                      ? store_default
                      : props?.storedetail?.images?.length > 0 ? props?.storedetail?.images[0] : store_default 
                  }
                  alt={""}
                  onError={(event) => {
                    event.target.src = store_default;
                  }}
                ></LazyLoadImage>
              ) :(<LazyLoadImage
                  src={
                    props?.storedetail?.store_image === null ||
                    typeof props?.storedetail?.store_image === "undefined"
                      ? store_default
                      : props?.storedetail?.store_image
                  }
                  alt={""}
                  onError={(event) => {
                    event.target.src = store_default;
                  }}
                ></LazyLoadImage>)}
              </div>
              <div className={"detail"}>
                <div className="name">
                  <h5>{props?.type === "StoreDetails"? (props?.storedetail?.title) :(props?.storedetail?.store_name)}</h5>
                </div>
                <div className="delivery">
                  <label>
                    {t("pages.storeprofile.deliverytime")}:{" "}
                    {props?.storedetail?.delivery_max_time} {t("pages.hours")}{" "}
                  </label>
                </div>
                <div className="address">
                  <i className="mask_icon map_icon pr-color"/>
                  <span>{props?.type === "StoreDetails"? (props?.storedetail?.address):(props?.storedetail?.store_address)}</span>
                </div>
              </div>
            </div>
          </div>
          {props?.editBanner && (
            <div className="setup_banner_div">
              <input type="file" accept="image/*" id="cloud_file" onChange={props?.onChange} style={{ display: "none" }} />
              <label className="banner-file" htmlFor="cloud_file" >
                <img src={cloud_file} alt="edit"></img>
              </label>
            </div>
          )}
        </div>
        {props?.showchat &&(
        <div className="information_btn">
          {props?.storeId !== props?.storeDetails?.store_id && (
            <div className={"btn p-0"}>
              <ButtonPage
                Text={<React.Fragment>
                <LazyLoadImage
                  src={message_icon}
                  style={{ width: "22px" }}
                  className="me-2"
                  alt={""}
                ></LazyLoadImage>
                {t("pages.chat.Chat with vendor")}
                </React.Fragment>}
                onClick={(e) => navigateTochat(e)}
                className="button-submit chatwith-vendor"
                type="button"
              />
            </div>
          )}
        </div>)}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  storeDetail: state?.dashboard?.storeDetail,
  logindata: state?.login?.logindata,
});

export default connect(mapStateToProps)(StoreProfile);
